// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"da51a739f7--image-wrapper--VqeOq"};